import { actions } from './slice';
import { getPatientsBloodPressure, getBloodPressure } from './actions';

const allActions = {
  ...actions,
  getPatientsBloodPressure,
  getBloodPressure,
};

export { allActions as bloodPressureActions };
export { reducer as bloodPressureReducer } from './slice';
